const config = {
  brand: window?.env?.brand || "TGS",
};

export default config;
